import { createSlice } from '@reduxjs/toolkit';

import { entityPlayersAdapter } from './entity-players.selector';
import { searchEntityPlayer, searchNextEntityPlayer } from './entity-players.thunk';
import { EntityPlayersState } from './entity-players.type';

export const entityPlayersInitialState: EntityPlayersState = entityPlayersAdapter.getInitialState({});

export const { reducer: entityPlayersReducer, actions: entityPlayersActions } = createSlice({
  name: 'entityPlayers',
  initialState: entityPlayersInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(searchEntityPlayer.pending, (state, payload) => {
      const { entityId, entityType } = payload.meta.arg.entity;

      if (state.entities[entityId]) {
        return entityPlayersAdapter.updateOne(state, {
          id: entityId,
          changes: {
            metadata: {
              total: state.entities[entityId]?.metadata.total || 0,
              loading: true,
              error: null,
              next: state.entities[entityId]?.metadata.next || null,
            },
          },
        });
      }

      return entityPlayersAdapter.addOne(state, {
        entityId,
        entityType,
        players: [],
        metadata: {
          total: 0,
          loading: true,
          error: null,
          next: null,
        },
      });
    });

    builder.addCase(searchEntityPlayer.fulfilled, (state, { payload, meta }) => {
      const { entityId } = meta.arg.entity;

      return entityPlayersAdapter.updateOne(state, {
        id: entityId,
        changes: {
          players: [...payload.items],
          metadata: {
            total: payload.total,
            loading: false,
            error: null,
            next: payload.next,
          },
        },
      });
    });

    builder.addCase(searchNextEntityPlayer.fulfilled, (state, { payload, meta }) => {
      const { entityId } = meta.arg;
      const oldPlayers = state.entities[entityId]?.players ?? [];
      if (!payload) {
        return state;
      }

      return entityPlayersAdapter.updateOne(state, {
        id: entityId,
        changes: {
          players: [...oldPlayers, ...payload.items],
          metadata: {
            total: payload.total,
            loading: false,
            error: null,
            next: payload.next,
          },
        },
      });
    });
  },
});
